import { Injectable } from '@angular/core'
import { SmODataConfiguration } from '@exchange/services/core/odata'
import { IModelBase } from 'common-components'
import { HttpClient } from '@angular/common/http'
import { ODataService } from 'common-services'

export interface IProcessorDefinitionBlocklist extends IModelBase {
  Id: number
  ProcessorDefinitionId: number
  EntityGroupId: number
}

@Injectable()
export class ProcessorDefinitionBlocklistODataService extends ODataService<IProcessorDefinitionBlocklist> {
  constructor(
    protected http: HttpClient,
    protected config: SmODataConfiguration
  ) {
    super(http, config)
    this.typeName = 'ProcessorDefinitionBlocklist'
  }
}
